import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "ic-localizacao_32a9494bd6a48738c94b7bb8d5e9a543",
  "use": "ic-localizacao_32a9494bd6a48738c94b7bb8d5e9a543-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"ic-localizacao_32a9494bd6a48738c94b7bb8d5e9a543\">\n    <path fill-rule=\"nonzero\" d=\"M16 7c-3.594 0-6.5 2.817-6.5 6.3C9.5 18.025 16 25 16 25s6.5-6.975 6.5-11.7C22.5 9.817 19.594 7 16 7zm0 8.55c-1.281 0-2.321-1.008-2.321-2.25s1.04-2.25 2.321-2.25c1.281 0 2.321 1.008 2.321 2.25s-1.04 2.25-2.321 2.25z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id